<ion-header>
  <ion-toolbar>
    <ion-title>{{(action === 'add'? 'general.add' : 'general.edit') | translate}} {{'tracking.workout' | translate}} {{(mode === 'program'? 'trainingPrograms.program' : 'pages.training.programTemplate.template') | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form class="formStyle2" #formData='ngForm' (ngSubmit)="onSubmit(formData)"
    [ngClass]="{'submitted': isFormSubmitted}">

    <ion-row>
      <ion-col>
          <ion-item class="ion-no-padding">
            <ion-label position="stacked">{{'workoutProgramBuilder.programTitle' | translate}}</ion-label>
            <ion-textarea autoGrow class="formControl" 
              maxlength="100"
              type="text" #title="ngModel" [(ngModel)]="workoutProgram.title" name="title" required>
                <span class="counter">{{getCounter(workoutProgram.title, 100)}}</span>
            </ion-textarea>
          </ion-item>
          <div class="field-error" *ngIf="(isFormSubmitted || title.touched) && title.errors?.required">
              <span>{{'general.progTitleRequired' | translate}}</span>
          </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="mode === 'template'">
      <ion-col>
          <ion-item class="ion-no-padding">
            <ion-label position="stacked">{{'general.description' | translate}}</ion-label>
            <ion-textarea class="formControl" #description="ngModel" [(ngModel)]="workoutProgram.description" name="description"></ion-textarea>
          </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="mode === 'program' && type === 'user'">
      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'general.start' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtStart" [owlDateTime]="dtStart" #startDate="ngModel" name="startDate"
              class="formControl" [(ngModel)]="dates.start" required>
            <owl-date-time #dtStart [hour12Timer]="true" stepMinute="60"></owl-date-time>
          </div>
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || startDate.touched) && startDate.errors?.required">
            <span>{{'general.start_date_required' | translate}}</span>
        </div>
      </ion-col>

      <ion-col size="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProg' | translate}}</ion-label>
          <ion-toggle name="startDateHidden" [disabled]="!dates.start" [(ngModel)]="workoutProgram.startDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>

    </ion-row>
      
    <ion-row *ngIf="mode === 'program' && type === 'user'">
      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'general.end' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtEnd" [owlDateTime]="dtEnd" #endDate="ngModel" name="endDate"
              class="formControl" [(ngModel)]="dates.end" (ngModelChange)="endDateChanged($event)">
            <owl-date-time #dtEnd [hour12Timer]="true" stepMinute="60" [startAt]="endPickerStartAt"></owl-date-time>
          </div>
        </ion-item>
      </ion-col>


      <ion-col size="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProdEnd' | translate}}</ion-label>
          <ion-toggle name="endDateHidden" [disabled]="!dates.end" [(ngModel)]="workoutProgram.endDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!premium">
      <ion-col size-lg="6" *ngIf="mode === 'program' || mode === 'workout'">
          <ion-item class="ion-no-padding">
            <ion-label position="stacked">{{'pages.training.workout.focus' | translate}}</ion-label>
            <ion-input class="formControl" type="text" #focus="ngModel" [(ngModel)]="workoutProgram.focus" name="focus" required></ion-input>
          </ion-item>
          <div class="field-error" *ngIf="(isFormSubmitted || focus.touched) && focus.errors?.required">
              <span>{{'workoutProgramBuilder.focusRequired' | translate}}</span>
          </div>
      </ion-col>

      <ion-col size-lg="6">
        <ion-item>
          <ion-label position="stacked">{{'general.dificulty' | translate}}</ion-label>
         <mat-select   #level="ngModel" [(ngModel)]="workoutProgram.level" name="level" required>
            <mat-option value="1">{{'general.beginer' | translate}}</mat-option>
            <mat-option value="2">{{'general.intermediate' | translate}}</mat-option>
            <mat-option value="3">{{'general.advanced' | translate}}</mat-option>
          </mat-select> 
                    
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || level.touched) && level.errors?.required">
          <span>{{'general.difficultyRequired' | translate}}</span>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!premium">
      <ion-col size-lg="6" *ngIf="mode === 'program' || mode === 'workout'">
        <ion-item>
          <ion-label position="stacked">{{'general.gender' | translate}}</ion-label>
          <!-- <ion-select class="formControl" #gender="ngModel" [(ngModel)]="workoutProgram.gender" name="gender" required>
            <ion-select-option [value]="'female'">Female</ion-select-option>
            <ion-select-option [value]="'male'">Male</ion-select-option>
          </ion-select>                      -->
          <mat-select   #gender="ngModel" [(ngModel)]="workoutProgram.gender" name="gender" required>
            <mat-option value="female">{{'general.female' | translate}}</mat-option>
            <mat-option value="male">{{'general.male' | translate}}</mat-option>

          </mat-select>
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || gender.touched) && gender.errors?.required">
          <span>{{'general.genderRequired' | translate}}</span>
        </div>
      </ion-col>
    <!-- </ion-row>

      <ion-row> -->
      <ion-col size-lg="6" *ngIf="programGoals">
        <ion-item>
          <ion-label position="stacked">{{mode === 'program'? ('trainingPrograms.program' | translate) + ' ' : ''}}{{'general.goal' | translate}}</ion-label>
          <mat-select    #goal="ngModel" [(ngModel)]="workoutProgram.goal" name="goal" required>
            <mat-option *ngFor="let option of programGoals | keyvalue" [value]="option.key">{{option.value}}
            </mat-option>
          </mat-select>
          <!-- <ion-select class="formControl" #goal="ngModel" [(ngModel)]="workoutProgram.goal" name="goal" required>
            <ion-select-option *ngFor="let option of programGoals | keyvalue" [value]="option.key">{{option.value}}</ion-select-option>
          </ion-select>                      -->
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || goal.touched) && goal.errors?.required">
          <span>{{'general.goalRequired' | translate}}</span>
        </div>
      </ion-col>
    </ion-row>
  </form>

</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="secondary" size="small" (click)="formData.ngSubmit.emit()">
        {{'general.submit' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
